import ZaiaSelect from "./ZaiaSelect";

export default ZaiaSelect;